import React from 'react';
export default function Brand({ large = false }) {
  return <span className={`korean-brand${large ? ' korean-brand-large' : ''}`}><img src="/images/korean-logo.jpeg" alt="Korean Lash Lift by Ali" width="1560" height="1560" /></span>;
}
